import { Component } from 'react'
import _ from 'lodash'
import cx from 'classnames'
import styles from './index.css'
import Cascader from '../../Cascader'
import InputPicker from '../../InputPicker'
import SelectedPaths from './SelectedPaths'

class CascaderWithSelectedPath extends Component {
  constructor (props) {
    super(props)
    this.state = {
      selectedOptions: [],
      selectedPathsLabels: []
    }
  }

  componentDidMount () {
    const { selectedOptions } = this.state
    const {
      options,
      autoSetValues,
      defaultValue
    } = this.props
    if (autoSetValues && _.isEmpty(selectedOptions) && defaultValue) {
      const defaultSelectedOption = _.find(options, { value: _.get(defaultValue, '0') })
      if (!_.isEmpty(defaultSelectedOption)) {
        this.setState({
          selectedOptions: [defaultSelectedOption],
          selectedPathsLabels: defaultValue
        })
      }
    }
  }

  handleChange = (selectedPathsLabels, selectedOptions) => {
    const { onChange } = this.props
    onChange && onChange(selectedPathsLabels, selectedOptions)
    this.setState({ selectedOptions, selectedPathsLabels })
  }

  handleLoadData = async (selectedOptions) => {
    const { loadData } = this.props
    const targetOption = _.get(selectedOptions, selectedOptions.length - 1, {})
    _.set(targetOption, 'loading', true)
    let targetOptionChildren = null
    if (loadData) {
      targetOptionChildren = await loadData(selectedOptions)
    }
    _.set(targetOption, 'loading', false)
    // get data 失敗時回傳 null，這樣才能重新點選項重抓一次選單資料
    if (!_.isNull(targetOptionChildren)) {
      _.set(targetOption, 'children', targetOptionChildren)
    }
    this.setState({ selectedOptions })
  }

  render () {
    const {
      selectedOptions: selectedOptionsFromState,
      selectedPathsLabels: selectedValuesFromState
    } = this.state
    const {
      inputPickerClassName,
      selectedPaths: selectedOptionsFromProps,
      value: selectedValuesFromProps,
      readOnly,
      processVisible,
      autoSetValues,
      loadData,
      placeholder,
      ...restProps
    } = this.props
    const [selectedOptions, selectedValues, handleLoadData] = autoSetValues
      ? [
        selectedOptionsFromState,
        selectedValuesFromState,
        this.handleLoadData
      ]
      : [
        selectedOptionsFromProps,
        selectedValuesFromProps,
        loadData
      ]
    const SelectPathComponent = _.isEmpty(selectedOptions)
      ? null
      : (
        <SelectedPaths
          selectedOptions={selectedOptions}
          processVisible={processVisible}
        />
      )
    return (
      <Cascader
        {...restProps}
        value={selectedValues}
        loadData={handleLoadData}
        onChange={this.handleChange}
      >
        <InputPicker
          className={cx(
            styles.cascaderPicker,
            { [inputPickerClassName]: inputPickerClassName },
            { disabled: readOnly }
          )}
          data-role='cascader-selector-picker'
          value={SelectPathComponent}
          placeholder={placeholder}
        />
      </Cascader>
    )
  }
}

export default CascaderWithSelectedPath
